import React, { memo, useCallback } from "react";
import blobContentToBase64 from "src/lib/blobContentToBase64";
import getFilenameFromS3Link from "src/lib/getFilenameFromS3Link";

const handleDownload = async (url, data) => {
  if (!url) return;

  try {
    const r = await fetch(url);
    const blob = await r.blob();
    const base64 = await blobContentToBase64(blob);

    const file_name_orig = getFilenameFromS3Link(url);
    const ext = file_name_orig.slice(file_name_orig.lastIndexOf("."));

    const dateStr = new Date(data.createdAt).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).replace(/ /g, "_");

    const finalFileName = `${data.clinicName || 'Clinic'}_${dateStr}${ext}`;

    const link = document.createElement("a");
    link.href = base64;
    link.download = finalFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Download failed", error);
  }
};

const BankingDetails = ({ data }) => {
  const { bankAccountNumber, ifscCode, cancelledCheque } = data || {};

  if (bankAccountNumber && ifscCode) {
    return (
      <div className="banking-cell-text">
        <strong>A/C:</strong> {bankAccountNumber} <br />
        <strong>IFSC:</strong> {ifscCode}
      </div>
    );
  }

  if (cancelledCheque) {
    return (
      <button
        type="button"
        className="docg-save-btn pt-1 pb-1"
        style={{ lineHeight: "25px", cursor: 'pointer' }}
        onClick={() => handleDownload(cancelledCheque, data)}
      >
        Download Cheque
      </button>
    );
  }

  // 4. Logic: Fallback - No data available
  return <span style={{ color: '#999', fontStyle: 'italic' }}>No details provided</span>;
};

export default BankingDetails;